let state = {
  PJ_Catalogos_001Areas: {},
  PJ_Catalogos_002Materias: {},
  PJ_Catalogos_004TiposDocumento: {},
  PJ_Catalogos_005PuestoJuridico: {},
  PJ_Catalogos_006PuestoAdministrativo: {},
  PJ_Catalogos_008Delitos: {},
  PJ_Catalogos_009PartidosJudiciales: {},
  PJ_Catalogos_010Municipios: {},
  PJ_Catalogos_011EntidadesFederativas: {},
  PJ_Catalogos_012TiposSexo: {},
  PJ_Catalogos_020Salas: {},
  PJ_Catalogos_024TipoAudiencia: {},
  PJ_Catalogos_027TipoTitulo: {},
  PJ_Catalogos_029TipoPersonalidad: {},
  PJ_Catalogos_031Sistema: {},
  PJ_Catalogos_034TipoEvidencia: {},
  PJ_Catalogos_037PaisId: -1,
  PJ_Catalogos_038TiposIdentificacion: {},
  PJ_Catalogos_041TiposEstadoCivil: {},
  PJ_Catalogos_042Juicios: {},
  PJ_Catalogos_042JuicioId_TemisCivil: -1,
  PJ_Catalogos_046Tramites: {},
  PJ_Catalogos_046TramiteId_TemisCivil: -1,
  PJ_Catalogos_048TipoFirmaElectronicaId: null,
  PJ_Catalogos_044TiposPuestos: -1,
  PJ_Catalogos_045Puestos:{},
  PJ_Catalogos_045PuestoId: -1,
  PJ_Catalogos_045PuestoNombre: null ,
  PJ_Catalogos_051AnexoId: -1,
  PJ_Catalogos_052NivelPuestoId: -1,
  PJ_Catalogos_060TipoCategoriaPuestoId: -1,
  PJ_Catalogos_EstablecerOrigenOficioId: -1
}

let getters = {
    Get_PJ_Catalogos_001Area: state => {
        return state.PJ_Catalogos_001Areas;
    },
    Get_PJ_Catalogos_005PuestoJuridico: state => {
      return state.PJ_Catalogos_005PuestoJuridico;
    },
    Get_PJ_Catalogos_006PuestoAdministrativo: state => {
      return state.PJ_Catalogos_006PuestoAdministrativo;
    },
    Get_PJ_Catalogos_008Delitos: state => {
      return state.PJ_Catalogos_008Delitos;
  },
    Get_PJ_Catalogos_009PartidoJudicialId: state => {
        return state.PJ_Catalogos_009PartidosJudiciales;
    },
    Get_PJ_Catalogos_012TipoSexo: state => {
        return state.PJ_Catalogos_012TiposSexo;
    },
    Get_PJ_Catalogos_027TipoTitulo: state => {
      return state.PJ_Catalogos_027TipoTitulo;
    },
    Get_PJ_Catalogos_029TipoPersonalidad: state => {
        return state.PJ_Catalogos_029TipoPersonalidad;
    },
    Get_PJ_Catalogos_031Sistemas: state => {
      return state.PJ_Catalogos_031Sistema;
    },
    Get_PJ_Catalogos_037Pais: state => {
        return state.PJ_Catalogos_037PaisId;
    },
    Get_PJ_Catalogos_038TiposIdentificacion: state => {
        return state.PJ_Catalogos_038TiposIdentificacion;
    },
    Get_PJ_Catalogos_039TiposDepartamento: state => {
        return state.PJ_Catalogos_039TiposDepartamento;
    },
    Get_PJ_Catalogos_041TipoEstadoCivil: state => {
        return state.SIAP_Catalogos_041TipoEstadoCivilId;
    },
    Get_PJ_Catalogos_042Juicio: state => {
        return state.PJ_Catalogos_042Juicios;
    },
    Get_PJ_Catalogos_042Juicio_TemisCivil: state => {
      return state.PJ_Catalogos_042JuicioId_TemisCivil;
  },
    Get_PJ_Catalogos_044TiposPuestos: state => {
      return state.PJ_Catalogos_044TiposPuestoId;
    },
    Get_PJ_Catalogos_045Puestos: state => {
        return state.PJ_Catalogos_045PuestoId;
    },
    Get_PJ_Catalogos_046Tramite: state => {
        return state.PJ_Catalogos_046Tramites;
    },
    Get_PJ_Catalogos_046Tramite_TemisCivil: state => {
      return state.PJ_Catalogos_046TramiteId_TemisCivil;
  },
    Get_PJ_Catalogos_048TipoFirmaElectronica: state => {
        return state.PJ_Catalogos_048TipoFirmaElectronicaId;
    },
    Get_PJ_Catalogos_045Puestos: state => {
      return state.PJ_Catalogos_045PuestoId;
    },
    Get_PJ_Catalogos_045PuestosNombre: state => {
      return state.PJ_Catalogos_045PuestoNombre;
    },
    Get_PJ_Catalogos_052NivelesPuestos: state => {
      return state.PJ_Catalogos_052NivelPuestoId;
    },
    Get_PJ_Catalogos_060TipoCategoriaPuesto: state => {
      return state.PJ_Catalogos_060TipoCategoriaPuestoId;
    },
    Get_PJ_Catalogos_OrigenOficio: state => {
      return state.PJ_Catalogos_EstablecerOrigenOficioId;
    }      
}

let mutations = {
  M_PJ_Catalogos_001Area(state, data) {
    state.PJ_Catalogos_001Areas[data.llave] = data.valor;
  },
  M_PJ_Catalogos_002Materia(state, data) {
    state.PJ_Catalogos_002Materias[data.llave] = data.valor;
  },
  M_PJ_Catalogos_004TipoDocumento(state, data) {    
    state.PJ_Catalogos_004TiposDocumento[data.llave] = data.valor;
  },
  M_PJ_Catalogos_005PuestoJuridico(state, data) {    
    state.PJ_Catalogos_005PuestoJuridico[data.llave] = data.valor;
  },
  M_PJ_Catalogos_006PuestoAdministrativo(state, data) {    
    state.PJ_Catalogos_006PuestoAdministrativo[data.llave] = data.valor;
  },
  M_PJ_Catalogos_008Delito(state, data) {
    state.PJ_Catalogos_008Delitos[data.llave] = data.valor;
  },
  M_PJ_Catalogos_009PartidoJudicial(state, data) {    
    state.PJ_Catalogos_009PartidosJudiciales[data.llave] = data.valor;
  },  
  M_PJ_Catalogos_010Municipio(state, data) {
    state.PJ_Catalogos_010Municipios[data.llave] = data.valor;
  },
  M_PJ_Catalogos_011EntidadFederativa(state,data){
    state.PJ_Catalogos_011EntidadesFederativas[data.llave] = data.valor;
  },
  M_PJ_Catalogos_020Sala(state, data) {
    state.PJ_Catalogos_020Salas[data.llave] = data.valor;
  },
  M_PJ_Catalogos_024TipoAudiencia(state, data) {
    state.PJ_Catalogos_024TipoAudiencia[data.llave] = data;
  },
  M_PJ_Catalogos_027TipoTitulo(state, data) {
    state.PJ_Catalogos_027TipoTitulo[data.llave] = data;
  },
  M_PJ_Catalogos_029TipoPersonalidad(state, data) {
    state.PJ_Catalogos_029TipoPersonalidad[data.llave] = data;
  },
  M_PJ_Catalogos_031Sistema(state, data) {
    state.PJ_Catalogos_031Sistema[data.llave] = data;
  },
  M_PJ_Catalogos_034TipoEvidencia(state, data) {
    state.PJ_Catalogos_034TipoEvidencia[data.llave] = data;
  },
  M_PJ_Catalogos_038TiposIdentificacion(state, data) {
    state.PJ_Catalogos_038TiposIdentificacion[data.llave] = data.valor;
  },  
  M_PJ_Catalogos_041TipoEstadoCivil(state,data){
    state.PJ_Catalogos_041TiposEstadoCivil[data.llave] = data.valor;
  },
  M_PJ_Catalogos_042Juicio(state, data) {
    state.PJ_Catalogos_042Juicios = data;
  },
  M_PJ_Catalogos_042Juicio_TemisCivil(state, data) {
    state.PJ_Catalogos_042JuicioId_TemisCivil = data;
  },
  M_PJ_Catalogos_046Tramite(state, data) {
    state.PJ_Catalogos_046Tramites = data;
  },
  M_PJ_Catalogos_046Tramite_TemisCivil(state, data) {
    state.PJ_Catalogos_046TramiteId_TemisCivil = data;
  },
  M_PJ_Catalogos_048TipoFirmaElectronica(state, data) {
    state.PJ_Catalogos_048TipoFirmaElectronicaId = data;
  },  
  M_PJ_Catalogos_037Pais(state, data) {
    state.PJ_Catalogos_037PaisId = data;
  },
  M_PJ_Catalogos_012TipoSexo(state, data) {
    state.PJ_Catalogos_012TiposSexo[data.llave] = data.valor;
  },
  M_PJ_Catalogos_044TipoPuesto(state, data) {
    state.PJ_Catalogos_044TipoPuestoId = data;
  },
  M_PJ_Catalogos_045Puesto(state, data) {
    state.PJ_Catalogos_045PuestoId = data;
  },
  M_PJ_Catalogos_Establecer051Anexo(state, data) {
    state.PJ_Catalogos_051AnexoId = data;
  },
  M_PJ_Catalogos_Establecer052NivelPuesto(state, data) {
    state.PJ_Catalogos_052NivelPuestoId = data;
  },  
  M_PJ_Catalogos_Establecer060TipoCategoriaPuesto(state, data) {
    state.PJ_Catalogos_060TipoCategoriaPuestoId = data;
  },
  M_PJ_Catalogos_EstablecerOrigenOficio(state, data) {
    state.PJ_Catalogos_EstablecerOrigenOficioId = data;
  } 
}

let actions = {
  A_PJ_Catalogo_Establecer001Area: ({ commit }, data) => {    
    commit('M_PJ_Catalogos_001Area', data);
  },
  A_PJ_Catalogo_Establecer002Materia: ({ commit }, data) => {
    commit('M_PJ_Catalogos_002Materia', data);
  },  
  A_PJ_Catalogo_Establecer004TipoDocumento: ({ commit }, data) => {    
    commit('M_PJ_Catalogos_004TipoDocumento', data);
  },
  A_PJ_Catalogo_Establecer005PuestoJuridico: ({ commit }, data) => {    
    commit('M_PJ_Catalogos_005PuestoJuridico', data);
  },
  A_PJ_Catalogo_Establecer006PuestoAdministrativo: ({ commit }, data) => {    
    commit('M_PJ_Catalogos_006PuestoAdministrativo', data);
  },
  A_PJ_Catalogo_Establecer008Delitos: ({ commit }, data) => {
    commit('M_PJ_Catalogos_008Delito', data);
  },
  A_PJ_Catalogo_Establecer009PartidoJudicial: ({ commit }, data) => {    
    commit('M_PJ_Catalogos_009PartidoJudicial', data);
  },
  A_PJ_Catalogo_Establecer010Municipio: ({ commit }, data) => {
    commit('M_PJ_Catalogos_010Municipio', data)
  },  
  A_PJ_Catalogo_Establecer011EntidadFederativa:({ commit }, data)=>{
    commit('M_PJ_Catalogos_011EntidadFederativa', data)
  },
  A_PJ_Catalogo_Establecer012TipoSexo: ({ commit }, data) => {
    commit('M_PJ_Catalogos_012TipoSexo', data)
  },
  A_PJ_Catalogo_Establecer020Sala: ({ commit }, data) => {
    commit('M_PJ_Catalogos_020Sala', data);
  },
  A_PJ_Catalogo_Establecer024TipoAudiencia: ({ commit }, data) => {
    commit('M_PJ_Catalogos_024TipoAudiencia', data)
  },
  A_PJ_Catalogo_Establecer027TipoTitulo: ({ commit }, data) => {
    commit('M_PJ_Catalogos_027TipoTitulo', data)
  },
  A_PJ_Catalogo_Establecer029TipoPersonalidad: ({ commit }, data) => {
    commit('M_PJ_Catalogos_029TipoPersonalidad', data)
  },
  A_PJ_Catalogo_Establecer031Sistema: ({ commit }, data) => {
    commit('M_PJ_Catalogos_031Sistema', data)
  },
  A_PJ_Catalogo_Establecer034TipoEvidencia: ({ commit }, data) => {
    commit('M_PJ_Catalogos_034TipoEvidencia', data)
  },
  A_PJ_Catalogo_Establecer037Pais: ({ commit }, data) => {
    commit('M_PJ_Catalogos_037Pais', data)
  },
  A_PJ_Catalogo_Establecer038TiposIdentificacion: ({ commit }, data) => {
    commit('M_PJ_Catalogos_038TiposIdentificacion', data)
  },
  A_PJ_Catalogo_Establecer041TipoEstadoCivil: ({ commit }, data) => {
    commit('M_PJ_Catalogos_041TipoEstadoCivil', data)
  },
  A_PJ_Catalogo_Establecer042Juicio: ({ commit }, data) => {
    commit('M_PJ_Catalogos_042Juicio', data)
  },
  A_PJ_Catalogo_Establecer042Juicio_TemisCivil: ({ commit }, data) => {
    commit('M_PJ_Catalogos_042Juicio_TemisCivil', data)
  },
  A_PJ_Catalogo_Establecer046Tramite: ({ commit }, data) => {
    commit('M_PJ_Catalogos_046Tramite', data)
  },
  A_PJ_Catalogo_Establecer046Tramite_TemisCivil: ({ commit }, data) => {
    commit('M_PJ_Catalogos_046Tramite_TemisCivil', data)
  },
  A_PJ_Catalogo_Establecer048TiposFirmaElectronica: ({ commit }, data) => {
    commit('M_PJ_Catalogos_048TipoFirmaElectronica', data)
  },
  A_PJ_Catalogo_Establecer044TipoPuesto: ({ commit }, data) => {
    commit('M_PJ_Catalogos_044TipoPuesto', data)
  },
  A_PJ_Catalogo_Establecer045Puesto: ({ commit }, data) => {
    commit('M_PJ_Catalogos_045Puesto', data)
  },
  A_PJ_Catalogos_Establecer051Anexo: ({ commit }, data) => {
    commit('M_PJ_Catalogos_Establecer051Anexo', data)
  },
  A_PJ_Catalogos_Establecer052NivelPuesto: ({ commit }, data) => {
    commit('M_PJ_Catalogos_Establecer052NivelPuesto', data)
  },
  A_PJ_Catalogos_Establecer060TipoCategoriaPuesto: ({ commit }, data) => {
    commit('M_PJ_Catalogos_Establecer060TipoCategoriaPuesto', data)
  },
  A_PJ_Catalogos_EstablecerOrigenOficio: ({ commit }, data) => {
    commit('M_PJ_Catalogos_EstablecerOrigenOficio', data)
  }
}

const PJ = {
    State: state,
    Getters: getters,
    Mutations: mutations,
    Actions: actions
}
export default PJ;



// WEBPACK FOOTER //
// ./src/store/PJ.js